import PropTypes from 'prop-types';

/**
 * Some shared code extracted from EssentialsListPromo and EssentialsListCard.
 */
export const EssentialsListDescription = ({ teacherName, topItemName, topItemPrice, isPromo, location }) => {
    return (
        <div>
            {(isPromo ? '' : <h3 className="header"><span className="price">${topItemPrice}</span> <span className="subtext">{topItemName}</span></h3>)}
            <span className="teacher-secondary-info">{(isPromo ? <span>Help a teacher spend less out of pocket. <br></br>Give {topItemName} </span> : '')}
                for <span className="teacher">{teacherName}</span> <span className="in">in</span> <div className="location">{location}</div>
            </span>
        </div>
    );
};
EssentialsListDescription.propTypes = {
    teacherName: PropTypes.string.isRequired,
    topItemName: PropTypes.string.isRequired,
    topItemPrice: PropTypes.number.isRequired,
    isPromo: PropTypes.bool.isRequired,
    location: PropTypes.string,
};
